import { render } from "./PublicacaoEdital.vue?vue&type=template&id=10e634b8&scoped=true"
import script from "./PublicacaoEdital.vue?vue&type=script&lang=js"
export * from "./PublicacaoEdital.vue?vue&type=script&lang=js"

import "./PublicacaoEdital.vue?vue&type=style&index=0&id=10e634b8&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e634b8"]])

export default __exports__